import { setData } from '../project';
import { Alert } from 'react-native';

/* */
/*/
  return <View style={{ backgroundColor: 'pink', width: '150px', height: '150px' }} />;
/*/
/* */
// FYy - expo-update
type Tprops_FYy = { pass: { A: any; B: any } };
export const FYy =
  (props: Tprops_FYy) =>
  async (...args: any) => {
    const { A, B } = props.pass;

    // console.log('DENTRO EXPO-UPDATE', { A });
    // console.log({ B });
    setData({ path: 'sc.A1.loadingVersion', value: 'true' });

    const Updates = await import('expo-updates');

    try {
      const update = await Updates.checkForUpdateAsync();

      if (update.isAvailable) {
        console.warn({ update });

        const fnOk = async () => {
          await Updates.fetchUpdateAsync();
          await Updates.reloadAsync();
          // console.log('OK Pressed');
        };
        const msg1 =
          'Há uma nova versão do código do aplicativo. Deseja atualizar?';
        Alert.alert('Atualização do Código', msg1, [
          {
            text: 'Não',
            // onPress: () => console.log('Cancel Pressed'),
            style: 'cancel',
          },
          { text: 'Sim', onPress: fnOk },
        ]);
      } else {
        // alert(`Não há atualizações disponíveis.`);
      }
    } catch (error) {
      // alert(`Erro ao tentar fazer a última atualização: ${error}`);
    }

    setData({ path: 'sc.A1.loadingVersion', value: 'false' });
  };
